<script setup>
import { ref, watch } from 'vue';

// eslint-disable-next-line no-undef
const props = defineProps({
    label: {
        type: String,
        required: false,
    },
    required: {
        type: Boolean,
        required: false,
    },
    name: {
        type: String,
        default: 'radio-btn-options',
    },
    options: [Array, Object],
    modelValue: {
        type: [String, Object],
        default: '',
    },
    listItemClass: {
        type: String,
        default: '',
    },
    labelClass: {
        type: String,
        default: '',
    },
    tooltip: {
        type: String,
        default: '',
    },
});

// eslint-disable-next-line no-undef
const emit = defineEmits(['update:modelValue']);

const selectedOption = ref(props.modelValue);
// Watch for changes from parent
watch(() => props.modelValue, (newVal) => {
    selectedOption.value = newVal;
});
watch(selectedOption, (newVal) => {
    emit('update:modelValue', newVal);
});

function getOptionValue(option) {
    if (option === null || option === undefined) return null;
    return typeof option === 'object' ? option.value ?? option.id : option;
}

function optionSlotName(option) {
    return `option-${getOptionValue(option)}`;
}
</script>

<template>
    <div class="tw-flex tw-flex-col tw-gap-8 tw-justify-end">
        <label
            v-if="props.label"
            for=""
            class="!tw-text-[1.2em] tw-font-semibold"
            :class="props.labelClass"
        >
            {{ props.label }}
            <span v-if="props.required" class="tw-text-red-700">*</span>
            <!-- Additional Information -->
            <!-- TODO: no design given yet, if there is, use OverlayPanel instead if the layout is a bit complex -->
            <Button
                v-tooltip="'lorem ipsum dolor sit amet'"
                icon="pi pi-info-circle"
                :pt="{ icon: 'tw-text-2xl !tw-text-secondary' }"
                text
                rounded
            />
        </label>
        <div class="tw-flex tw-flex-col tw-gap-y-4">
            <div
                v-for="(option, index) in props.options"
                :key="option.id ?? index"
                class="tw-flex tw-flex-col"
            >
                <div class="tw-flex tw-gap-x-2 tw-items-center tw-pl-4">
                    <RadioButton
                        v-model="selectedOption"
                        :inputId="`option${index}`"
                        :name="props.name"
                        :value="option"
                    />
                    <label :for="`option${index}`" :class="props.listItemClass" class="tw-ml-2 !tw-text-[1.2em]">
                        {{ option.name ?? option }}
                    </label>
                </div>

                <!-- For slot based from option value -->
                <div class="tw-ml-16 tw-mt-2">
                    <slot :name="optionSlotName(option)" />
                </div>
            </div>
        </div>
    </div>
</template>
